import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

// https://www.codemzy.com/blog/clients-reload-single-page-application-update
export default function AppVersionChecker() {
  // check if a version update (refresh) needed on route change
  const location = useLocation();
  useLayoutEffect(() => {
    // if there is an update available and no state passed to route
    if (
      !location.state &&
      window.localStorage.getItem("version-update-needed")
    ) {
      window.localStorage.removeItem("version-update-needed"); // remove the storage object
      window.location.reload(); // refresh the browser
    }
  }, [location]);

  return null;
}
